// extracted by mini-css-extract-plugin
export var parcelRow = "_ud-0";